module.exports = __webpack_public_path__ + "assets/compare_arrows-24px.svg";